import {Typed} from "app/stimulus/typed-stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";
import {Controller} from "@hotwired/stimulus";

@AsStimulusController('admin-side-menu-item')
export default class extends Typed(
    Controller<HTMLElement>, {
        targets: {
            submenu: HTMLDivElement,
            openSubmenuIcon: HTMLElement,
            closeSubmenuIcon: HTMLElement,
        }
    }
)
{
    public toggleSubmenu(): void {
        if (!this.hasSubmenuTarget) {
            return;
        }
        const isHidden = this.submenuTarget.style.display === 'none';
        isHidden ? this.showSubmenu() : this.hideSubmenu();
    }

    public showSubmenu(): void {
        if (!this.hasSubmenuTarget) {
            return;
        }
        this.submenuTarget.style.display = '';
        if (this.hasOpenSubmenuIconTarget) {
            this.openSubmenuIconTarget.style.display = 'none';
        }
        if (this.hasCloseSubmenuIconTarget) {
            this.closeSubmenuIconTarget.style.display = '';
        }
    }

    public hideSubmenu(): void {
        if (!this.hasSubmenuTarget) {
            return;
        }
        this.submenuTarget.style.display = 'none';
        if (this.hasOpenSubmenuIconTarget) {
            this.openSubmenuIconTarget.style.display = '';
        }
        if (this.hasCloseSubmenuIconTarget) {
            this.closeSubmenuIconTarget.style.display = 'none';
        }
    }
}
